var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlayBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Livello_1",
    x: 0,
    y: 0,
    viewBox: "0 0 406.668 120",
    style: {
      enableBackground: "new 0 0 406.668 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0,.st1{fill-rule:evenodd;clip-rule:evenodd}.st1{fill:#a6a6a6}.st2,.st3{fill:#fff}.st3,.st4,.st5{fill-rule:evenodd;clip-rule:evenodd}.st4{fill:url(#SVGID_1_)}.st5{fill:url(#SVGID_2_)}.st6{fill:url(#SVGID_3_)}.st10,.st6,.st7,.st8,.st9{fill-rule:evenodd;clip-rule:evenodd}.st7{fill:url(#SVGID_4_)}.st10,.st8,.st9{enable-background:new}.st8{opacity:.2}.st9{opacity:.12}.st10{opacity:.25;fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M391.601,120H15.067C6.763,120,0,113.237,0,105V15C0,6.733,6.763,0,15.067,0h376.534 c8.297,0,15.067,6.733,15.067,15v90C406.668,113.237,399.898,120,391.601,120z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M391.601,2.401c6.965,0,12.666,5.663,12.666,12.599v90c0,6.935-5.663,12.599-12.666,12.599H15.067 c-6.965,0-12.666-5.663-12.666-12.599V15c0-6.935,5.663-12.599,12.666-12.599C15.067,2.401,391.601,2.401,391.601,2.401z M391.601,0 H15.067C6.763,0,0,6.763,0,15v90c0,8.267,6.763,15,15.067,15h376.534c8.297,0,15.067-6.733,15.067-15V15 C406.668,6.763,399.898,0,391.601,0z",
    className: "st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.234,39.696c-2.716,0-5.005-0.95-6.815-2.82c-1.796-1.818-2.798-4.324-2.753-6.883 c0-2.731,0.928-5.042,2.753-6.875c1.803-1.87,4.092-2.82,6.808-2.82c2.686,0,4.975,0.95,6.815,2.82 c1.825,1.893,2.753,4.204,2.753,6.875c-0.03,2.738-0.958,5.05-2.753,6.875C219.239,38.753,216.95,39.696,214.234,39.696z M133.429,39.696c-2.656,0-4.96-0.935-6.845-2.783c-1.87-1.84-2.82-4.167-2.82-6.913s0.95-5.072,2.82-6.913 c1.848-1.848,4.152-2.783,6.845-2.783c1.317,0,2.596,0.262,3.823,0.793c1.204,0.516,2.185,1.219,2.91,2.08l0.18,0.217l-2.027,1.99 l-0.209-0.247c-1.145-1.362-2.678-2.027-4.706-2.027c-1.81,0-3.389,0.643-4.691,1.915c-1.309,1.279-1.975,2.955-1.975,4.983 s0.666,3.703,1.975,4.983c1.302,1.272,2.88,1.915,4.691,1.915c1.93,0,3.554-0.643,4.818-1.915c0.748-0.748,1.212-1.796,1.377-3.12 h-6.501v-2.798h9.292l0.037,0.254c0.067,0.471,0.135,0.958,0.135,1.406c0,2.581-0.778,4.668-2.319,6.209 C138.486,38.768,136.197,39.696,133.429,39.696z M240.868,39.299h-2.865l-8.776-14.042l0.075,2.529v11.506h-2.865V20.701h3.269 l0.09,0.142l8.252,13.227l-0.075-2.521V20.701h2.895L240.868,39.299L240.868,39.299z M192.703,39.299H189.8v-15.8h-5.035v-2.798 h12.965v2.798h-5.035v15.8H192.703z M182.402,39.299h-2.895V20.701h2.895V39.299z M166.13,39.299h-2.895v-15.8H158.2v-2.798h12.965 v2.798h-5.035V39.299z M156.367,39.269h-11.102V20.701h11.102v2.798h-8.199v5.102h7.399v2.768h-7.399v5.102h8.199V39.269z M209.544,34.953c1.294,1.294,2.865,1.945,4.691,1.945c1.878,0,3.411-0.636,4.691-1.945c1.272-1.272,1.915-2.94,1.915-4.953 s-0.643-3.688-1.908-4.953c-1.294-1.294-2.873-1.945-4.691-1.945c-1.878,0-3.411,0.636-4.683,1.945 c-1.272,1.272-1.915,2.94-1.915,4.953S208.279,33.688,209.544,34.953L209.544,34.953z",
    className: "st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.397,65.267c-7.07,0-12.801,5.364-12.801,12.763c0,7.332,5.768,12.763,12.801,12.763 c7.07,0,12.801-5.401,12.801-12.763C217.197,70.631,211.466,65.267,204.397,65.267z M204.397,85.736 c-3.868,0-7.197-3.202-7.197-7.736c0-4.601,3.337-7.736,7.197-7.736c3.868,0,7.197,3.135,7.197,7.736 C211.601,82.564,208.264,85.736,204.397,85.736z M176.469,65.267c-7.07,0-12.801,5.364-12.801,12.763 c0,7.332,5.768,12.763,12.801,12.763c7.07,0,12.801-5.401,12.801-12.763C189.269,70.631,183.531,65.267,176.469,65.267z M176.469,85.736c-3.868,0-7.197-3.202-7.197-7.736c0-4.601,3.337-7.736,7.197-7.736c3.868,0,7.197,3.135,7.197,7.736 C183.666,82.564,180.337,85.736,176.469,85.736z M143.237,69.165v5.401h12.965c-0.396,3.03-1.399,5.267-2.933,6.8 c-1.9,1.9-4.833,3.965-10.002,3.965c-7.968,0-14.2-6.434-14.2-14.401s6.232-14.402,14.2-14.402c4.302,0,7.436,1.698,9.763,3.868 l3.83-3.83c-3.232-3.097-7.534-5.469-13.564-5.469c-10.93,0-20.102,8.903-20.102,19.803c0,10.93,9.165,19.803,20.102,19.803 c5.903,0,10.332-1.93,13.833-5.566c3.569-3.569,4.698-8.603,4.698-12.666c0-1.264-0.097-2.401-0.299-3.367h-18.299 C143.237,69.097,143.237,69.165,143.237,69.165z M279.165,73.369c-1.07-2.865-4.302-8.132-10.93-8.132 c-6.569,0-12.03,5.17-12.03,12.763c0,7.167,5.401,12.763,12.666,12.763c5.835,0,9.232-3.569,10.631-5.663l-4.332-2.903 c-1.436,2.132-3.434,3.531-6.269,3.531c-2.865,0-4.87-1.302-6.202-3.868l17.065-7.07C279.763,74.798,279.165,73.369,279.165,73.369z M261.763,77.633c-0.135-4.93,3.83-7.436,6.666-7.436c2.237,0,4.1,1.1,4.736,2.701L261.763,77.633z M247.9,90h5.603V52.504H247.9V90 z M238.698,68.102h-0.202c-1.264-1.504-3.666-2.865-6.733-2.865c-6.367,0-12.232,5.603-12.232,12.8 c0,7.167,5.835,12.703,12.232,12.703c3.03,0,5.469-1.369,6.733-2.903h0.202v1.833c0,4.87-2.603,7.496-6.8,7.496 c-3.434,0-5.566-2.469-6.434-4.534l-4.87,2.035c1.399,3.367,5.132,7.534,11.297,7.534c6.569,0,12.135-3.868,12.135-13.302V66h-5.297 v2.102C238.736,68.102,238.698,68.102,238.698,68.102z M232.264,85.736c-3.868,0-7.1-3.232-7.1-7.698c0-4.504,3.232-7.766,7.1-7.766 c3.83,0,6.8,3.299,6.8,7.766C239.102,82.504,236.102,85.736,232.264,85.736z M305.401,52.504h-13.399V90h5.603V75.8h7.803 c6.202,0,12.299-4.496,12.299-11.633S311.633,52.504,305.401,52.504z M305.566,70.564h-7.968V57.696h7.968 c4.197,0,6.569,3.464,6.569,6.434C312.135,67.07,309.733,70.564,305.566,70.564z M340.167,65.2c-4.07,0-8.267,1.803-10.003,5.731 l4.968,2.065c1.07-2.065,3.03-2.768,5.102-2.768c2.903,0,5.835,1.736,5.903,4.833v0.397c-1.003-0.569-3.202-1.436-5.835-1.436 c-5.364,0-10.803,2.933-10.803,8.431c0,5.035,4.399,8.267,9.299,8.267c3.763,0,5.835-1.698,7.13-3.666h0.202v2.903h5.402V75.591 C351.531,68.903,346.564,65.2,340.167,65.2z M339.464,85.736c-1.833,0-4.399-0.898-4.399-3.202c0-2.903,3.202-4.002,5.933-4.002 c2.469,0,3.636,0.531,5.102,1.264C345.696,83.162,342.853,85.706,339.464,85.736z M371.237,66l-6.434,16.264h-0.202L357.935,66 h-6.03l10.003,22.736l-5.701,12.636h5.835L377.431,66H371.237z M320.798,90h5.603V52.504h-5.603V90z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 3629.109,
    x2: 3624.784,
    y1: -186.339,
    y2: -184.107,
    gradientTransform: "matrix(11.64 0 0 22.55 -42177.4375 4228.0698)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00a0ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    style: {
      stopColor: "#00a1ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#00beff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    style: {
      stopColor: "#00d2ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#00dfff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00e3ff"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.302,22.601c-0.868,0.935-1.369,2.364-1.369,4.234v66.337c0,1.87,0.501,3.299,1.399,4.197l0.232,0.202 l37.167-37.167v-0.83L31.534,22.399L31.302,22.601z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 3540.176,
    x2: 3532.238,
    y1: -239.487,
    y2: -239.487,
    gradientTransform: "matrix(9.145 0 0 7.7 -32273.4082 1904.0511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#ffbd00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    style: {
      stopColor: "orange"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c00"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.097,72.83L68.701,60.434v-0.868L81.097,47.17l0.269,0.165l14.663,8.334c4.197,2.364,4.197,6.269,0,8.663 l-14.663,8.334C81.367,72.666,81.097,72.83,81.097,72.83z",
    className: "st5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 3705.248,
    x2: 3700.702,
    y1: -211.604,
    y2: -205.707,
    gradientTransform: "matrix(15.02 0 0 11.5775 -55578.3477 2516.7329)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff3a44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c31162"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.367,72.666L68.701,60L31.302,97.399c1.369,1.466,3.666,1.631,6.232,0.202L81.367,72.666",
    className: "st6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    x1: 3701.747,
    x2: 3703.776,
    y1: -216.364,
    y2: -213.729,
    gradientTransform: "matrix(15.02 0 0 11.5715 -55578.3477 2504.1934)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32a071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#2da771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    style: {
      stopColor: "#15cf74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    style: {
      stopColor: "#06e775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00f076"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.367,47.334L37.534,22.436c-2.566-1.466-4.87-1.264-6.232,0.202L68.701,60L81.367,47.334z",
    className: "st7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.097,72.397L37.564,97.13c-2.431,1.399-4.601,1.302-6,0.03l-0.232,0.232l0.232,0.202 c1.399,1.264,3.569,1.369,6-0.03l43.833-24.898L81.097,72.397z",
    className: "st8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.03,63.898l-14.97,8.499l0.269,0.269l14.663-8.334c2.102-1.197,3.135-2.768,3.135-4.332 C99,61.436,97.93,62.798,96.03,63.898z",
    className: "st9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.534,22.87L96.03,56.102c1.9,1.07,2.97,2.469,3.135,3.898c0-1.564-1.032-3.135-3.135-4.332L37.534,22.436 c-4.197-2.401-7.601-0.397-7.601,4.399v0.434C29.933,22.466,33.337,20.499,37.534,22.87z",
    className: "st10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBlack);
export default __webpack_public_path__ + "static/media/google-play-black.c0bc3350b9a1f59b7de6a67d02bfb57c.svg";
export { ForwardRef as ReactComponent };